import { Alert } from "@mui/material";

export const DoNotEditAlert = () => (
  <Alert severity="warning" sx={{ mb: 1 }}>
    The Invoice Has Already Been Transfered To QuickBooks, And So It Is
    Recommended That It Not Be Edited.
  </Alert>
);
